import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalDataType } from './modal-data-type.interface';

@Injectable()
export class ConfirmationService {
  private requireConfirmationSource = new Subject<ModalDataType>();
  private acceptConfirmationSource = new Subject<ModalDataType | void>();

  requireConfirmation$ = this.requireConfirmationSource.asObservable();
  accept = this.acceptConfirmationSource.asObservable();

  confirm(confirmation: ModalDataType) {
    this.requireConfirmationSource.next(confirmation);
    return this;
  }

  onAccept() {
    this.acceptConfirmationSource.next();
  }
}
